<script lang="ts">
  import { getCopy } from "../../lib/stores/copy";
  import { navigateToPath } from "../../lib/routing";
  import Button from "../Button.svelte";
  import { settingsStore } from "../../lib/stores/settings";
  import PATHS from "../../lib/constants/routePaths";
  import GenericErrorPage from "./GenericErrorPage.svelte";

  export let currentRoute: { name: string; path: string };

  function onCheckZones() {
    navigateToPath(PATHS.DELIVERY_ZONES);
  }

  $: copy = $getCopy("noSupport") as Record<string, string>;
  $: isShowDeliveryZones = $settingsStore.showDeliveryZones && $settingsStore.deliveryZones;
</script>

<GenericErrorPage {currentRoute}>
  <svelte:fragment slot="button">
    {#if isShowDeliveryZones}
      <Button primary class="mt-8 lg:max-w-max" on:click={onCheckZones}>{copy.checkAvailabilityLink}</Button>
    {/if}
  </svelte:fragment>
</GenericErrorPage>
